import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
    providedIn: 'root'
})
export class AccountService {

    get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }

    constructor(private http: HttpClient) { }

    saveMachineMapping(data: any): Observable<any> {
        return this.http.post(this.O3CoreApiUrl + 'account/SumbitMachineMapping', data);
    }
    getMachineMappingList(data: any): Observable<any> {
        return this.http.post(this.O3CoreApiUrl + `account/GetMachineMappingList`, data);
    }


    deleteMachineMapping(userMachineMappingId: number): Observable<any> {
        return this.http.delete(this.O3CoreApiUrl + `account/DeleteMachineMapping/${userMachineMappingId}`);
    }
}
